module.exports = __webpack_public_path__ + "static/img/1000000501_green.5db5bed2.jpg";